import { Message, MessagesPerDays } from "./types";

export function getMessagesPerDays(messages: Message[]): MessagesPerDays {
    const now = Number(new Date());

    return messages.reduce((acc, message) => {
        const milliSecondsAgo = message.minutesAgo * 60 * 1000;
        const strDate = new Date(now - milliSecondsAgo).toDateString();

        if (acc[strDate]) {
            return { ...acc, [strDate]: [...acc[strDate], message] };
        }
        return { ...acc, [strDate]: [message] };
    }, {} as MessagesPerDays);
}
